import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { InventoryLocationValueLog } from "../../models/inventory-location";

interface StoreDebtLogDeleteModalProps {
  show: boolean;
  storeDebtLog?: InventoryLocationValueLog;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const StoreDebtLogDeleteModal: React.FC<StoreDebtLogDeleteModalProps> = ({
  show,
  storeDebtLog,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = storeDebtLog
    ? `Está seguro de que quiere eliminar el registro de la tienda ${storeDebtLog.storeName}. esta accion no se puede deshacer`
    : "";

  const onDeleteClick = async () => {
    if (storeDebtLog !== undefined) {
      setSubmitting(true);
      const supplierStatus = await deleteItem<InventoryLocationValueLog>(
        `/inventory_locations/value_logs/${storeDebtLog.id}/`,
        storeDebtLog
      );

      if (supplierStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (supplierStatus.detail !== undefined) {
          message = supplierStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default StoreDebtLogDeleteModal;
